// import { useEffect, useState, useMemo } from "react";
// import api from "../api";

// const todayISO = new Date().toISOString().slice(0, 10);

// const AdminDailySheet = () => {
//   const [entries, setEntries] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [viewMode, setViewMode] = useState("daily"); // daily | weekly | monthly
//   const [baseDate, setBaseDate] = useState(todayISO);
//   const [empCodeFilter, setEmpCodeFilter] = useState("");

//   // NEW: frontend-only status filter
//   const [statusFilter, setStatusFilter] = useState("");

//   const [editingId, setEditingId] = useState(null);
//   const [reviewForm, setReviewForm] = useState({
//     manager_status: "REVIEWED",
//     manager_comment: "",
//   });

//   const [upcomingLeaves, setUpcomingLeaves] = useState([]);

//   // ----------------------------
//   // DATE RANGE CALCULATOR
//   // ----------------------------
//   const getRangeFromView = (mode, baseIso) => {
//     const base = new Date(baseIso);

//     if (mode === "daily") {
//       return { start: baseIso, end: baseIso };
//     }

//     if (mode === "weekly") {
//       const day = base.getDay();
//       const diffToMonday = (day + 6) % 7;

//       const startDate = new Date(base);
//       startDate.setDate(base.getDate() - diffToMonday);

//       const endDate = new Date(startDate);
//       endDate.setDate(startDate.getDate() + 6);

//       const toISO = (d) => d.toISOString().slice(0, 10);
//       return { start: toISO(startDate), end: toISO(endDate) };
//     }

//     if (mode === "monthly") {
//       const year = base.getFullYear();
//       const month = base.getMonth();

//       const start = new Date(year, month, 1);
//       const end = new Date(year, month + 1, 0);

//       const toISO = (d) => d.toISOString().slice(0, 10);
//       return { start: toISO(start), end: toISO(end) };
//     }
//   };

//   // ----------------------------------
//   // LOAD ENTRIES FROM BACKEND
//   // ----------------------------------
//   useEffect(() => {
//     refreshData();
//     // eslint-disable-next-line
//   }, [viewMode, baseDate, empCodeFilter]);

//   useEffect(() => {
//     loadUpcomingLeaves();
//     }, []);

//     const loadUpcomingLeaves = async () => {
//   try {
//     const res = await api.get("/admin/daily-sheet/upcoming-leaves");
//     setUpcomingLeaves(res.data || []);
//   } catch (err) {
//     console.error("Error loading upcoming leaves", err);
//   }
// };



//   const refreshData = async () => {
//     const { start, end } = getRangeFromView(viewMode, baseDate);
//     await loadEntries(start, end);
//   };

//   const loadEntries = async (start, end) => {
//     setLoading(true);
//     try {
//       const params = { start, end };
//       if (empCodeFilter.trim()) params.emp_code = empCodeFilter.trim();

//       const res = await api.get("/admin/daily-sheet", { params });
//       setEntries(res.data || []);
//     } catch (err) {
//       console.error("Entries error", err);
//       alert("Error loading daily sheet entries");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ----------------------------------
//   // FRONTEND SUMMARY CALCULATION
//   // ----------------------------------
//   const summary = useMemo(() => {
//     const data = entries.filter((e) =>
//       statusFilter ? e.status === statusFilter : true
//     );

//     const sum = {
//       Assignment: 0,
//       WFH: 0,
//       Leave: 0,
//       "Half Day": 0,
//       Vacation: 0,
//     };

//     data.forEach((e) => {
//       if (sum[e.status] !== undefined) sum[e.status] += 1;
//     });

//     return sum;
//   }, [entries, statusFilter]);

//   // ----------------------------------
//   // MANAGER INLINE REVIEW
//   // ----------------------------------
//   const startEdit = (entry) => {
//     setEditingId(entry.id);
//     setReviewForm({
//       manager_status: entry.manager_status || "PENDING",
//       manager_comment: entry.manager_comment || "",
//     });
//   };

//   const cancelEdit = () => {
//     setEditingId(null);
//     setReviewForm({
//       manager_status: "REVIEWED",
//       manager_comment: "",
//     });
//   };

//   const saveReview = async (id) => {
//     try {
//       await api.put(`/admin/daily-sheet/${id}/manager-review`, reviewForm);
//       await refreshData();
//       setEditingId(null);
//     } catch (err) {
//       console.error("Review update error", err);
//       alert("Error updating review");
//     }
//   };

//   // ----------------------------------
//   // HELPERS
//   // ----------------------------------
//   const formatDate = (iso) => {
//     const d = new Date(iso);
//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const statusBadgeClass = (status) => {
//     if (status === "REVIEWED") return "badge badge-success";
//     if (status === "FLAGGED") return "badge badge-danger";
//     return "badge badge-warning";
//   };

//   const viewModeLabel = () => {
//     if (viewMode === "daily") return "Daily";
//     if (viewMode === "weekly") return "Weekly";
//     return "Monthly";
//   };

//   // ----------------------------------
//   // UI
//   // ----------------------------------
//   return (

    
//     <div className="card">
//         {/* UPCOMING LEAVE LIST */}
// <div className="card" style={{ marginBottom: 20 }}>
//   <div className="card-header">
//     <h2>Upcoming Leaves (Next 30 Days)</h2>
//     <p className="text-muted">Employees who applied for leave from today to next 30 days.</p>
//   </div>

//   {upcomingLeaves.length === 0 ? (
//     <p className="text-muted" style={{ margin: 10 }}>
//       No upcoming leaves in the next 30 days.
//     </p>
//   ) : (
//     <div style={{ overflowX: "auto" }}>
//       <table className="table">
//         <thead>
//           <tr>
//             <th>Date</th>
//             <th>Emp Code</th>
//             <th>Name</th>
//             <th>Comment</th>
//             <th>Manager Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {upcomingLeaves.map((e, index) => (
//             <tr key={index}>
//               <td>{formatDate(e.entry_date)}</td>
//               <td>{e.emp_code}</td>
//               <td>{e.first_name} {e.last_name}</td>
//               <td style={{ maxWidth: 250, whiteSpace: "pre-wrap" }}>{e.comment}</td>
//               <td>
//                 <span className={statusBadgeClass(e.manager_status || "PENDING")}>
//                   {e.manager_status || "PENDING"}
//                 </span>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   )}
// </div>

//       <div className="card-header">
//         <h2>Team Daily Sheet</h2>
//         <p className="text-muted">
//           View employee daily logs in {viewModeLabel().toLowerCase()} mode and
//           review them.
//         </p>
//       </div>

//       {/* FILTERS */}
//       <form
//         className="filter-row"
//         onSubmit={(e) => {
//           e.preventDefault();
//           refreshData();
//         }}
//       >
//         {/* View Mode */}
//         <div>
//           <label className="filter-label">View Type</label>
//           <div className="view-mode-toggle">
//             <button
//               type="button"
//               className={
//                 "view-mode-btn" +
//                 (viewMode === "daily" ? " view-mode-btn-active" : "")
//               }
//               onClick={() => setViewMode("daily")}
//             >
//               Daily
//             </button>
//             <button
//               type="button"
//               className={
//                 "view-mode-btn" +
//                 (viewMode === "weekly" ? " view-mode-btn-active" : "")
//               }
//               onClick={() => setViewMode("weekly")}
//             >
//               Weekly
//             </button>
//             <button
//               type="button"
//               className={
//                 "view-mode-btn" +
//                 (viewMode === "monthly" ? " view-mode-btn-active" : "")
//               }
//               onClick={() => setViewMode("monthly")}
//             >
//               Monthly
//             </button>
//           </div>
//         </div>

//         {/* Reference Date */}
//         <div>
//           <label className="filter-label">Reference Date</label>
//           <input
//             type="date"
//             className="filter-input"
//             value={baseDate}
//             onChange={(e) => setBaseDate(e.target.value)}
//           />
//         </div>

//         {/* Employee Code */}
//         <div>
//           <label className="filter-label">Employee Code</label>
//           <input
//             className="filter-input"
//             placeholder="e.g. 20"
//             value={empCodeFilter}
//             onChange={(e) => setEmpCodeFilter(e.target.value)}
//           />
//         </div>

//         {/* Status Filter */}
//         <div>
//           <label className="filter-label">Status</label>
//           <select
//             className="filter-input"
//             value={statusFilter}
//             onChange={(e) => setStatusFilter(e.target.value)}
//           >
//             <option value="">All</option>
//             <option value="Assignment">Assignment</option>
//             <option value="WFH">WFH</option>
//             <option value="Leave">Leave</option>
//             <option value="Half Day">Half Day</option>
//             <option value="Vacation">Vacation</option>
//           </select>
//         </div>

//         <button className="btn btn-secondary" type="submit" disabled={loading}>
//           {loading ? "Loading..." : "Apply"}
//         </button>
//       </form>
              
//     {(
//     // DAILY → Always show summary
//     viewMode === "daily" ||

//     // WEEKLY & MONTHLY → Show only if employee code is given
//     (viewMode !== "daily" && empCodeFilter.trim() !== "")) && (
//     <div className="kpi-row" style={{ marginTop: 12, marginBottom: 12 }}>
//         <div className="kpi-card-sheet">
//         <h4>Assignment</h4>
//         <p>{summary.Assignment}</p>
//         </div>
//         <div className="kpi-card-sheet">
//         <h4>WFH</h4>
//         <p>{summary.WFH}</p>
//         </div>
//         <div className="kpi-card-sheet">
//         <h4>Leave</h4>
//         <p>{summary.Leave}</p>
//         </div>
//         <div className="kpi-card-sheet">
//         <h4>Half Day</h4>
//         <p>{summary["Half Day"]}</p>
//         </div>
//         <div className="kpi-card-sheet">
//         <h4>Vacation</h4>
//         <p>{summary.Vacation}</p>
//         </div>
//     </div>
//     )}

//       {/* TABLE */}
//       {entries.length === 0 ? (
//         <p className="text-muted" style={{ marginTop: 20 }}>
//           No entries for this {viewModeLabel().toLowerCase()} view.
//         </p>
//       ) : (
//         <div style={{ overflowX: "auto" }}>
//           <table className="table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Emp Code</th>
//                 <th>Name</th>
//                 <th>Dept</th>
//                 <th>Status</th>
//                 <th>Hours</th>
//                 <th>Employee Comment</th>
//                 <th>Manager Status</th>
//                 <th>Manager Comment / Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {entries
//                 .filter((e) =>
//                   statusFilter ? e.status === statusFilter : true
//                 )
//                 .map((e) => (
//                   <tr key={e.id}>
//                     <td>{formatDate(e.entry_date)}</td>
//                     <td>{e.emp_code}</td>
//                     <td>
//                       {e.first_name} {e.last_name}
//                     </td>
//                     <td>{e.department}</td>
//                     <td>{e.status}</td>
//                     <td>{e.hours || "-"}</td>
//                     <td style={{ maxWidth: 260, whiteSpace: "pre-wrap" }}>
//                       {e.comment}
//                     </td>
//                     <td>
//                       <span className={statusBadgeClass(e.manager_status)}>
//                         {e.manager_status}
//                       </span>
//                     </td>

//                     <td style={{ minWidth: 260 }}>
//                       {editingId === e.id ? (
//                         <div>
//                           <select
//                             className="field-input"
//                             style={{ marginBottom: 4 }}
//                             value={reviewForm.manager_status}
//                             onChange={(ev) =>
//                               setReviewForm((f) => ({
//                                 ...f,
//                                 manager_status: ev.target.value,
//                               }))
//                             }
//                           >
//                             <option value="PENDING">PENDING</option>
//                             <option value="REVIEWED">REVIEWED</option>
//                             <option value="FLAGGED">FLAGGED</option>
//                           </select>

//                           <textarea
//                             className="field-input"
//                             rows={3}
//                             placeholder="Manager comment..."
//                             value={reviewForm.manager_comment}
//                             onChange={(ev) =>
//                               setReviewForm((f) => ({
//                                 ...f,
//                                 manager_comment: ev.target.value,
//                               }))
//                             }
//                           />

//                           <div style={{ marginTop: 4 }}>
//                             <button
//                               className="btn btn-primary"
//                               onClick={() => saveReview(e.id)}
//                             >
//                               Save
//                             </button>{" "}
//                             <button
//                               className="btn btn-secondary"
//                               onClick={cancelEdit}
//                             >
//                               Cancel
//                             </button>
//                           </div>
//                         </div>
//                       ) : (
//                         <div>
//                           <div style={{ fontSize: 12, color: "#666" }}>
//                             {e.manager_comment || <em>No comment</em>}
//                           </div>
//                           <button
//                             className="btn btn-secondary"
//                             style={{
//                               marginTop: 4,
//                               padding: "2px 8px",
//                               fontSize: 12,
//                             }}
//                             onClick={() => startEdit(e)}
//                           >
//                             {e.manager_comment ? "Edit Review" : "Add Review"}
//                           </button>
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminDailySheet;











// import { useEffect, useState, useMemo } from "react";
// import api from "../api";

// const todayISO = new Date().toISOString().slice(0, 10);

// const AdminDailySheet = () => {
//   const [activeTab, setActiveTab] = useState("team"); // team | leaves

//   const [entries, setEntries] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [viewMode, setViewMode] = useState("daily");
//   const [baseDate, setBaseDate] = useState(todayISO);
//   const [empCodeFilter, setEmpCodeFilter] = useState("");

//   const [statusFilter, setStatusFilter] = useState("");

//   const [editingId, setEditingId] = useState(null);
//   const [reviewForm, setReviewForm] = useState({
//     manager_status: "REVIEWED",
//     manager_comment: "",
//   });

//   const [upcomingLeaves, setUpcomingLeaves] = useState([]);

//   // --------------------------
//   //   DATE RANGE CALCULATOR
//   // --------------------------
//   const getRangeFromView = (mode, baseIso) => {
//     const base = new Date(baseIso);

//     if (mode === "daily") return { start: baseIso, end: baseIso };

//     if (mode === "weekly") {
//       const day = base.getDay();
//       const diffToMonday = (day + 6) % 7;

//       const startDate = new Date(base);
//       startDate.setDate(base.getDate() - diffToMonday);

//       const endDate = new Date(startDate);
//       endDate.setDate(startDate.getDate() + 6);

//       const toISO = (d) => d.toISOString().slice(0, 10);
//       return { start: toISO(startDate), end: toISO(endDate) };
//     }

//     const year = base.getFullYear();
//     const month = base.getMonth();

//     const start = new Date(year, month, 1);
//     const end = new Date(year, month + 1, 0);

//     const toISO = (d) => d.toISOString().slice(0, 10);
//     return { start: toISO(start), end: toISO(end) };
//   };

//   // --------------------------
//   //   LOAD DATA
//   // --------------------------
//   useEffect(() => {
//     if (activeTab === "team") refreshData();
//     // eslint-disable-next-line
//   }, [activeTab, viewMode, baseDate, empCodeFilter]);

//   useEffect(() => {
//     loadUpcomingLeaves();
//   }, []);

//   const loadUpcomingLeaves = async () => {
//     try {
//       const res = await api.get("/admin/daily-sheet/upcoming-leaves");
//       setUpcomingLeaves(res.data || []);
//     } catch (err) {
//       console.error("Upcoming leaves error", err);
//     }
//   };

//   const refreshData = async () => {
//     const { start, end } = getRangeFromView(viewMode, baseDate);
//     await loadEntries(start, end);
//   };

//   const loadEntries = async (start, end) => {
//     setLoading(true);
//     try {
//       const params = { start, end };
//       if (empCodeFilter.trim()) params.emp_code = empCodeFilter.trim();

//       const res = await api.get("/admin/daily-sheet", { params });
//       setEntries(res.data || []);
//     } catch (err) {
//       console.error("Error loading entries", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // --------------------------
//   // SUMMARY (FRONTEND ONLY)
//   // --------------------------
//   const summary = useMemo(() => {
//     const data = entries.filter((e) =>
//       statusFilter ? e.status === statusFilter : true
//     );

//     const sum = {
//       Assignment: 0,
//       WFH: 0,
//       Leave: 0,
//       "Half Day": 0,
//       Vacation: 0,
//     };

//     data.forEach((e) => {
//       if (sum[e.status] !== undefined) sum[e.status] += 1;
//     });

//     return sum;
//   }, [entries, statusFilter]);

//   // --------------------------
//   // MANAGER REVIEW
//   // --------------------------
//   const startEdit = (entry) => {
//     setEditingId(entry.id);
//     setReviewForm({
//       manager_status: entry.manager_status || "PENDING",
//       manager_comment: entry.manager_comment || "",
//     });
//   };

//   const cancelEdit = () => {
//     setEditingId(null);
//     setReviewForm({
//       manager_status: "REVIEWED",
//       manager_comment: "",
//     });
//   };

//   const saveReview = async (id) => {
//     try {
//       await api.put(`/admin/daily-sheet/${id}/manager-review`, reviewForm);
//       await refreshData();
//       setEditingId(null);
//     } catch (err) {
//       console.error("Review update error", err);
//       alert("Error updating review");
//     }
//   };

//   // --------------------------
//   // HELPERS
//   // --------------------------
//   const formatDate = (iso) => {
//     const d = new Date(iso);
//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const statusBadgeClass = (status) => {
//     if (status === "REVIEWED") return "badge badge-success";
//     if (status === "FLAGGED") return "badge badge-danger";
//     return "badge badge-warning";
//   };

//   const viewModeLabel = () => {
//     if (viewMode === "daily") return "Daily";
//     if (viewMode === "weekly") return "Weekly";
//     return "Monthly";
//   };

//   // --------------------------
//   // UI
//   // --------------------------
//   return (
//     <div className="card">

//       {/* TOP NAVIGATION TABS */}
//       <div className="tab-header">
//         <button
//           className={activeTab === "team" ? "tab-btn active" : "tab-btn"}
//           onClick={() => setActiveTab("team")}
//         >
//           Team Daily Sheet
//         </button>

//         <button
//           className={activeTab === "leaves" ? "tab-btn active" : "tab-btn"}
//           onClick={() => setActiveTab("leaves")}
//         >
//           Upcoming Leaves
//         </button>
//       </div>

//       {/* -------------------------------- */}
//       {/* TAB 1: TEAM DAILY SHEET */}
//       {/* -------------------------------- */}
//       {activeTab === "team" && (
//         <>
//           {/* FILTERS */}
//           <form
//             className="filter-row"
//             onSubmit={(e) => {
//               e.preventDefault();
//               refreshData();
//             }}
//           >
//             {/* View Mode */}
//             <div>
//               <label className="filter-label">View Type</label>
//               <div className="view-mode-toggle">
//                 <button
//                   type="button"
//                   className={
//                     "view-mode-btn" +
//                     (viewMode === "daily" ? " view-mode-btn-active" : "")
//                   }
//                   onClick={() => setViewMode("daily")}
//                 >
//                   Daily
//                 </button>

//                 <button
//                   type="button"
//                   className={
//                     "view-mode-btn" +
//                     (viewMode === "weekly" ? " view-mode-btn-active" : "")
//                   }
//                   onClick={() => setViewMode("weekly")}
//                 >
//                   Weekly
//                 </button>

//                 <button
//                   type="button"
//                   className={
//                     "view-mode-btn" +
//                     (viewMode === "monthly" ? " view-mode-btn-active" : "")
//                   }
//                   onClick={() => setViewMode("monthly")}
//                 >
//                   Monthly
//                 </button>
//               </div>
//             </div>

//             {/* Reference Date */}
//             <div>
//               <label className="filter-label">Ref Date</label>
//               <input
//                 type="date"
//                 className="filter-input"
//                 value={baseDate}
//                 onChange={(e) => setBaseDate(e.target.value)}
//               />
//             </div>

//             {/* Employee Code */}
//             <div>
//               <label className="filter-label">Emp Code</label>
//               <input
//                 className="filter-input"
//                 value={empCodeFilter}
//                 onChange={(e) => setEmpCodeFilter(e.target.value)}
//                 placeholder="E.g. 20"
//               />
//             </div>

//             {/* Status Filter */}
//             <div>
//               <label className="filter-label">Status</label>
//               <select
//                 className="filter-input"
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//               >
//                 <option value="">All</option>
//                 <option value="Assignment">Assignment</option>
//                 <option value="WFH">WFH</option>
//                 <option value="Leave">Leave</option>
//                 <option value="Half Day">Half Day</option>
//                 <option value="Vacation">Vacation</option>
//               </select>
//             </div>

//             {/* <button className="btn btn-secondary" type="submit">
//               Apply
//             </button> */}
//           </form>

//           {/* SUMMARY */}
//           {(viewMode === "daily" ||
//             (viewMode !== "daily" && empCodeFilter.trim() !== "")) && (
//             <div className="kpi-row" style={{ marginTop: 12 }}>
//               <div className="kpi-card-sheet">
//                 <h4>Assignment</h4>
//                 <p>{summary.Assignment}</p>
//               </div>
//               <div className="kpi-card-sheet">
//                 <h4>WFH</h4>
//                 <p>{summary.WFH}</p>
//               </div>
//               <div className="kpi-card-sheet">
//                 <h4>Leave</h4>
//                 <p>{summary.Leave}</p>
//               </div>
//               <div className="kpi-card-sheet">
//                 <h4>Half Day</h4>
//                 <p>{summary["Half Day"]}</p>
//               </div>
//               <div className="kpi-card-sheet">
//                 <h4>Vacation</h4>
//                 <p>{summary.Vacation}</p>
//               </div>
//             </div>
//           )}

//           {/* MAIN TABLE */}
//           {entries.length === 0 ? (
//             <p className="text-muted" style={{ marginTop: 20 }}>
//               No entries for this {viewModeLabel().toLowerCase()} view.
//             </p>
//           ) : (
//             <div style={{ overflowX: "auto" }}>
//               <table className="table">
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>Emp Code</th>
//                     <th>Name</th>
//                     <th>Dept</th>
//                     <th>Status</th>
//                     <th>Hours</th>
//                     <th>Employee Comment</th>
//                     <th>Manager Status</th>
//                     <th>Manager Comment / Action</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {entries
//                     .filter((e) =>
//                       statusFilter ? e.status === statusFilter : true
//                     )
//                     .map((e) => (
//                       <tr key={e.id}>
//                         <td>{formatDate(e.entry_date)}</td>
//                         <td>{e.emp_code}</td>
//                         <td>
//                           {e.first_name} {e.last_name}
//                         </td>
//                         <td>{e.department}</td>
//                         <td>{e.status}</td>
//                         <td>{e.hours || "-"}</td>

//                         {/* Comment */}
//                         <td style={{ maxWidth: 260, whiteSpace: "pre-wrap" }}>
//                           {e.comment}
//                         </td>

//                         {/* Manager Status */}
//                         <td>
//                           <span className={statusBadgeClass(e.manager_status)}>
//                             {e.manager_status}
//                           </span>
//                         </td>

//                         {/* Manager Action */}
//                         <td style={{ minWidth: 260 }}>
//                           {editingId === e.id ? (
//                             <div>
//                               <select
//                                 className="field-input"
//                                 style={{ marginBottom: 4 }}
//                                 value={reviewForm.manager_status}
//                                 onChange={(ev) =>
//                                   setReviewForm((f) => ({
//                                     ...f,
//                                     manager_status: ev.target.value,
//                                   }))
//                                 }
//                               >
//                                 <option value="PENDING">PENDING</option>
//                                 <option value="REVIEWED">REVIEWED</option>
//                                 <option value="FLAGGED">FLAGGED</option>
//                               </select>

//                               <textarea
//                                 className="field-input"
//                                 rows={3}
//                                 placeholder="Manager comment..."
//                                 value={reviewForm.manager_comment}
//                                 onChange={(ev) =>
//                                   setReviewForm((f) => ({
//                                     ...f,
//                                     manager_comment: ev.target.value,
//                                   }))
//                                 }
//                               />

//                               <div style={{ marginTop: 4 }}>
//                                 <button
//                                   className="btn btn-primary"
//                                   onClick={() => saveReview(e.id)}
//                                 >
//                                   Save
//                                 </button>{" "}
//                                 <button
//                                   className="btn btn-secondary"
//                                   onClick={cancelEdit}
//                                 >
//                                   Cancel
//                                 </button>
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               <div style={{ fontSize: 12, color: "#666" }}>
//                                 {e.manager_comment || <em>No comment</em>}
//                               </div>
//                               <button
//                                 className="btn btn-secondary"
//                                 style={{
//                                   marginTop: 4,
//                                   padding: "2px 8px",
//                                   fontSize: 12,
//                                 }}
//                                 onClick={() => startEdit(e)}
//                               >
//                                 {e.manager_comment ? "Edit Review" : "Add Review"}
//                               </button>
//                             </div>
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </>
//       )}

//       {/* -------------------------------- */}
//       {/* TAB 2: UPCOMING LEAVES */}
//       {/* -------------------------------- */}
//       {activeTab === "leaves" && (
//         <div className="card" style={{ marginTop: 10 }}>
//           <div className="card-header">
//             <h2>Upcoming Leaves (Next 30 Days)</h2>
//             <p className="text-muted">
//               Employees who applied for leave from today to the next 30 days.
//             </p>
//           </div>

//           {upcomingLeaves.length === 0 ? (
//             <p className="text-muted" style={{ margin: 10 }}>
//               No upcoming leaves.
//             </p>
//           ) : (
//             <div style={{ overflowX: "auto" }}>
//               <table className="table">
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>Emp Code</th>
//                     <th>Name</th>
//                     <th>Comment</th>
//                     <th>Manager Status</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {upcomingLeaves.map((e, idx) => (
//                     <tr key={idx}>
//                       <td>{formatDate(e.entry_date)}</td>
//                       <td>{e.emp_code}</td>
//                       <td>
//                         {e.first_name} {e.last_name}
//                       </td>
//                       <td style={{ maxWidth: 260, whiteSpace: "pre-wrap" }}>
//                         {e.comment}
//                       </td>
//                       <td>
//                         <span className={statusBadgeClass(e.manager_status)}>
//                           {e.manager_status || "PENDING"}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminDailySheet;













import { useEffect, useState, useMemo } from "react";
import api from "../api";
import { getAuthSession } from "../auth";

const todayISO = new Date().toISOString().slice(0, 10);

const AdminDailySheet = () => {
  const session = getAuthSession();
  const role = session?.role === "manager" ? "manager" : "admin";

  // base path and privileges depend on role
  const basePath = role === "manager" ? "/manager/daily-sheet" : "/admin/daily-sheet";
  // Managers should also see upcoming leaves and filter by employee code
  const canSeeUpcoming = true;
  const canFilterEmp = true;

  const [activeTab, setActiveTab] = useState("team"); // "team" | "leaves"

  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [viewMode, setViewMode] = useState("daily"); // daily | weekly | monthly
  const [baseDate, setBaseDate] = useState(todayISO);
  const [empQuery, setEmpQuery] = useState("");

  const [statusFilter, setStatusFilter] = useState("");

  const [editingId, setEditingId] = useState(null);
  const [reviewForm, setReviewForm] = useState({
    manager_status: "REVIEWED",
    manager_comment: "",
  });

  const [upcomingLeaves, setUpcomingLeaves] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [calEntries, setCalEntries] = useState([]);
  const [calMonth, setCalMonth] = useState(new Date().getMonth());
  const [calYear, setCalYear] = useState(new Date().getFullYear());
  const [missingByDay, setMissingByDay] = useState([]);
  const [selectedCalDate, setSelectedCalDate] = useState(null);
  const [missingList, setMissingList] = useState([]);
  const [pageEntries, setPageEntries] = useState(1);
  const [pageLeaves, setPageLeaves] = useState(1);
  const pageSize = 10;

  const normalizeDateStr = (val) => {
    if (!val) return "";
    const d = new Date(val);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
      d.getDate()
    ).padStart(2, "0")}`;
  };

  // ---------------------------------------------------
  // DATE RANGE CALCULATOR
  // ---------------------------------------------------
  const getRangeFromView = (mode, baseIso) => {
    const base = new Date(baseIso);

    if (mode === "daily") {
      return { start: baseIso, end: baseIso };
    }

    if (mode === "weekly") {
      const day = base.getDay();
      const diffToMonday = (day + 6) % 7;
      const start = new Date(base);
      start.setDate(base.getDate() - diffToMonday);

      const end = new Date(start);
      end.setDate(start.getDate() + 6);

      const toISO = (d) => d.toISOString().slice(0, 10);
      return { start: toISO(start), end: toISO(end) };
    }

    if (mode === "monthly") {
      const year = base.getFullYear();
      const month = base.getMonth();

      const start = new Date(year, month, 1);
      const end = new Date(year, month + 1, 0);

      const toISO = (d) => d.toISOString().slice(0, 10);
      return { start: toISO(start), end: toISO(end) };
    }
  };

  // ---------------------------------------------------
  // LOAD TEAM ENTRIES
  // ---------------------------------------------------
  useEffect(() => {
    if (activeTab === "team") refreshData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, viewMode, baseDate, empQuery, role]);

  useEffect(() => {
    setPageEntries(1);
  }, [statusFilter, entries, viewMode, baseDate, empQuery]);

  useEffect(() => {
    loadEmployees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadMissingCalendar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calMonth, calYear, employees]);

  const refreshData = async () => {
    const { start, end } = getRangeFromView(viewMode, baseDate);
    await loadEntries(start, end);
  };

  const loadEntries = async (start, end) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const params = { start, end };

      const res = await api.get(basePath, { params });
      const sorted = (res.data || []).sort(
        (a, b) => new Date(a.entry_date) - new Date(b.entry_date)
      );
      setEntries(sorted);
    } catch (err) {
      console.error("Entries error", err);
      if (err?.response?.status === 404 && err?.response?.data?.message) {
        setEntries([]);
        setErrorMsg(err.response.data.message);
      } else {
        setErrorMsg("Error loading entries");
      }
    } finally {
      setLoading(false);
    }
  };

  const loadEmployees = async () => {
    if (role !== "admin") {
      // managers derive team from calendar entries
      return;
    }
    try {
      const res = await api.get("/employees");
      setEmployees(res.data || []);
    } catch (err) {
      console.error("Error loading employees", err);
    }
  };

  const loadMissingCalendar = async () => {
    try {
      const pad = (n) => String(n).padStart(2, "0");
      const start = `${calYear}-${pad(calMonth + 1)}-01`;
      const daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
      const end = `${calYear}-${pad(calMonth + 1)}-${pad(daysInMonth)}`;
      const res = await api.get(basePath, {
        params: { start, end },
      });

      const rows = res.data || [];

      // Determine team list (admin: all employees, manager: team from rows)
      let teamList = employees;
      if (role === "manager") {
        const uniq = new Map();
        rows.forEach((r) => {
          if (!uniq.has(r.emp_id)) {
            uniq.set(r.emp_id, {
              id: r.emp_id,
              emp_code: r.emp_code,
              first_name: r.first_name,
              last_name: r.last_name,
              department: r.department,
            });
          }
        });
        const derivedTeam = Array.from(uniq.values());
        if (derivedTeam.length) {
          teamList = derivedTeam;
        }
      }

      const presentMap = new Map(); // date -> Set of emp_id
      rows.forEach((row) => {
        const d = normalizeDateStr(row.entry_date || "");
        if (!d) return;
        if (!presentMap.has(d)) presentMap.set(d, new Set());
        presentMap.get(d).add(row.emp_id);
      });

      const teamSize =
        role === "manager"
          ? (teamList && teamList.length) || 0
          : employees.length;

      const missingArr = [];
      for (let day = 1; day <= daysInMonth; day++) {
        const dateStr = `${calYear}-${pad(calMonth + 1)}-${pad(day)}`;
        const presentCount = presentMap.get(dateStr)?.size || 0;
        const missingCount = Math.max(0, teamSize - presentCount);
        missingArr.push({ date: dateStr, day, missing: missingCount });
      }

      setMissingByDay(missingArr);
      setCalEntries(res.data || []);
    } catch (err) {
      console.error("Error loading missing calendar", err);
    }
  };

  // ---------------------------------------------------
  // LOAD UPCOMING LEAVES
  // ---------------------------------------------------
  useEffect(() => {
    if (activeTab === "leaves" && canSeeUpcoming) loadUpcomingLeaves();
  }, [activeTab, canSeeUpcoming]);

  useEffect(() => {
    setPageLeaves(1);
  }, [upcomingLeaves]);

  const loadUpcomingLeaves = async () => {
    if (!canSeeUpcoming) return;
    try {
      const res = await api.get("/admin/daily-sheet/upcoming-leaves");
      const sorted = (res.data || []).sort(
        (a, b) => new Date(a.entry_date) - new Date(b.entry_date)
      );
      setUpcomingLeaves(sorted);
    } catch (err) {
      console.error("Error loading upcoming leaves", err);
    }
  };

  // ---------------------------------------------------
  // FRONTEND SUMMARY CALCULATION
  // ---------------------------------------------------
  const filteredEntries = useMemo(() => {
    const q = empQuery.trim().toLowerCase();
    return entries.filter((e) => {
      const matchQuery = q
        ? `${e.emp_code || ""} ${e.first_name || ""} ${e.last_name || ""}`
            .toLowerCase()
            .includes(q)
        : true;
      const matchStatus = statusFilter ? e.status === statusFilter : true;
      return matchQuery && matchStatus;
    });
  }, [entries, empQuery, statusFilter]);

  const summary = useMemo(() => {
    const data = filteredEntries;

    const sum = {
      Assignment: 0,
      WFH: 0,
      Leave: 0,
      "Half Day": 0,
      Vacation: 0,
    };

    data.forEach((e) => {
      if (sum[e.status] !== undefined) sum[e.status] += 1;
    });

    return sum;
  }, [filteredEntries]);

  const totalEntryPages = Math.max(
    1,
    Math.ceil((filteredEntries.length || 0) / pageSize)
  );
  const paginatedEntries = filteredEntries.slice(
    (pageEntries - 1) * pageSize,
    pageEntries * pageSize
  );

  const totalLeavePages = Math.max(
    1,
    Math.ceil((upcomingLeaves.length || 0) / pageSize)
  );
  const paginatedLeaves = upcomingLeaves.slice(
    (pageLeaves - 1) * pageSize,
    pageLeaves * pageSize
  );

  // ---------------------------------------------------
  // MANAGER INLINE REVIEW
  // ---------------------------------------------------
  const startEdit = (entry) => {
    setEditingId(entry.id);
    setReviewForm({
      manager_status: entry.manager_status || "PENDING",
      manager_comment: entry.manager_comment || "",
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setReviewForm({
      manager_status: "REVIEWED",
      manager_comment: "",
    });
  };

  const saveReview = async (id) => {
    try {
      await api.put(`${basePath}/${id}/manager-review`, reviewForm);
      await refreshData();
      setEditingId(null);
    } catch (err) {
      console.error("Review error", err);
      alert("Error saving review");
    }
  };

  // ---------------------------------------------------
  // HELPERS
  // ---------------------------------------------------
  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const statusBadgeClass = (s) => {
    if (s === "REVIEWED") return "badge badge-success";
    if (s === "FLAGGED") return "badge badge-danger";
    return "badge badge-warning";
  };

  const viewModeLabel = () =>
    viewMode === "daily" ? "Daily" : viewMode === "weekly" ? "Weekly" : "Monthly";

  const monthLabel = useMemo(() => {
    return new Date(calYear, calMonth, 1).toLocaleDateString("en-IN", {
      month: "long",
      year: "numeric",
    });
  }, [calMonth, calYear]);

  const startDay = useMemo(
    () => new Date(calYear, calMonth, 1).getDay(),
    [calYear, calMonth]
  );

  const daysInMonth = useMemo(
    () => new Date(calYear, calMonth + 1, 0).getDate(),
    [calYear, calMonth]
  );

  const missingMap = useMemo(() => {
    const m = new Map();
    missingByDay.forEach((d) => m.set(d.date, d.missing));
    return m;
  }, [missingByDay]);
  const todayStr = useMemo(() => new Date().toISOString().slice(0, 10), []);

  const handleCalDateClick = (dateStr) => {
    setSelectedCalDate(dateStr);
    // Determine team list (use loaded employees; fallback to unique from calendar entries)
    let teamList = employees;
    if (!teamList || teamList.length === 0) {
      const uniq = new Map();
      (calEntries || []).forEach((r) => {
        if (!uniq.has(r.emp_id)) {
          uniq.set(r.emp_id, {
            id: r.emp_id,
            emp_code: r.emp_code,
            first_name: r.first_name,
            last_name: r.last_name,
            department: r.department,
          });
        }
      });
      teamList = Array.from(uniq.values());
    }

    const present = new Set(
      (calEntries || [])
        .filter((row) => normalizeDateStr(row.entry_date || "") === dateStr)
        .map((row) => row.emp_id)
    );
    const missing = (teamList || []).filter((emp) => !present.has(emp.id));

    setMissingList(missing);
  };

  // ---------------------------------------------------
  // UI STARTS HERE
  // ---------------------------------------------------
  return (
    <div className="">
      <div className="tab-row">
        <button
          className={`tab-btn ${activeTab === "team" ? "tab-active" : ""}`}
          onClick={() => setActiveTab("team")}
        >
          {role === "manager" ? "Team Daily Sheet" : "Daily Sheet"}
        </button>

        {(
          role === "admin" || role === "manager"
        ) && (
          <button
            className={`tab-btn ${activeTab === "calendar" ? "tab-active" : ""}`}
            onClick={() => setActiveTab("calendar")}
          >
            Missing Entries
          </button>
        )}

        {canSeeUpcoming && (
          <button
            className={`tab-btn ${activeTab === "leaves" ? "tab-active" : ""}`}
            onClick={() => setActiveTab("leaves")}
          >
            Upcoming Leaves
          </button>
        )}
      </div>
    
    <div className="card">
      {/* -------------------------- */}
      {/* TAB 1 — TEAM DAILY SHEET  */}
      {/* -------------------------- */}
      {activeTab === "team" && (
        <>
          <div className="card-header">
            <h1>{role === "manager" ? "Team Daily Sheet" : "Daily Sheet"}</h1>
            <p className="text-muted">
              View employee logs in {viewModeLabel()} mode.
            </p>
          </div>

          {/* FILTER ROW */}
          <form
            className="filter-row"
            onSubmit={(e) => {
              e.preventDefault();
              refreshData();
            }}
          >
            {/* View Mode */}
            <div>
              <label className="filter-label">View Type</label>
              <div className="view-mode-toggle">
                {["daily", "weekly", "monthly"].map((m) => (
                  <button
                    key={m}
                    type="button"
                    className={`view-mode-btn ${
                      viewMode === m ? "view-mode-btn-active" : ""
                    }`}
                    onClick={() => setViewMode(m)}
                  >
                    {m.charAt(0).toUpperCase() + m.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            {/* Reference Date */}
            <div>
              <label className="filter-label">Reference Date</label>
              <input
                type="date"
                className="filter-input"
                value={baseDate}
                onChange={(e) => setBaseDate(e.target.value)}
              />
            </div>

            {/* Employee search (name or code) */}
            {canFilterEmp && (
              <div>
                <label className="filter-label">Employee (name or code)</label>
                <input
                  className="filter-input"
                  value={empQuery}
                  placeholder="e.g. Jane or 20"
                  onChange={(e) => setEmpQuery(e.target.value)}
                />
              </div>
            )}

            {/* Status filter */}
            <div>
              <label className="filter-label">Status</label>
              <select
                className="filter-input"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">All</option>
                <option value="Assignment">Assignment</option>
                <option value="WFH">WFH</option>
                <option value="Leave">Leave</option>
                <option value="Half Day">Half Day</option>
                <option value="Vacation">Vacation</option>
              </select>
            </div>

            {/* <button className="btn btn-secondary" type="submit">
              {loading ? "Loading..." : "Apply"}
            </button> */}
          </form>

          {/* SUMMARY */}
          {(viewMode === "daily" ||
            (viewMode !== "daily" && empQuery.trim() !== "")) && (
            <div className="kpi-row">
              {Object.keys(summary).map((key) => (
                <div className="kpi-card-sheet" key={key}>
                  <h4>{key}</h4>
                  <p>{summary[key]}</p>
                </div>
              ))}
            </div>
          )}

          {/* TABLE */}
          {errorMsg ? (
            <p className="text-muted" style={{ marginTop: 20 }}>
              {errorMsg}
            </p>
          ) : entries.length === 0 ? (
            <p className="text-muted" style={{ marginTop: 20 }}>
              No entries for this {viewModeLabel()} view.
            </p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Emp Code</th>
                    <th>Name</th>
                    <th>Dept</th>
                    <th>Status</th>
                    <th>Hours</th>
                    <th>Employee Comment</th>
                    <th>Manager Status</th>
                    <th>Manager Action</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedEntries.map((e) => (
                    <tr key={e.id}>
                      <td>{formatDate(e.entry_date)}</td>
                      <td>{e.emp_code}</td>
                      <td>
                        {e.first_name} {e.last_name}
                      </td>
                      <td>{e.department}</td>
                      <td>{e.status}</td>
                      <td>{e.hours || "-"}</td>
                      <td style={{ whiteSpace: "pre-wrap" }}>{e.comment}</td>
                      <td>
                        <span className={statusBadgeClass(e.manager_status)}>
                          {e.manager_status}
                        </span>
                      </td>

                      <td>
                        {editingId === e.id ? (
                          <div>
                            <select
                              className="field-input-manager"
                              style={{ marginBottom: 4 }}
                              value={reviewForm.manager_status}
                              onChange={(ev) =>
                                setReviewForm((f) => ({
                                  ...f,
                                  manager_status: ev.target.value,
                                }))
                              }
                            >
                              <option value="PENDING">PENDING</option>
                              <option value="REVIEWED">REVIEWED</option>
                              <option value="FLAGGED">FLAGGED</option>
                            </select>

                            <textarea
                              className="field-input-manager"
                              rows={3}
                              placeholder="Manager comment..."
                              value={reviewForm.manager_comment}
                              onChange={(ev) =>
                                setReviewForm((f) => ({
                                  ...f,
                                  manager_comment: ev.target.value,
                                }))
                              }
                            />

                            <div style={{ marginTop: 4 }}>
                              <button
                                className="btn btn-primary"
                                onClick={() => saveReview(e.id)}
                              >
                                Save
                              </button>
                              <button
                                className="btn btn-secondary"
                                onClick={cancelEdit}
                                style={{ marginLeft: 6 }}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <button
                            className="btn btn-secondary"
                            style={{ padding: "2px 8px", fontSize: 12 }}
                            onClick={() => startEdit(e)}
                          >
                            {e.manager_comment ? "Edit Review" : "Add Review"}
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pagination-row">
                <button
                  className="btn btn-secondary"
                  onClick={() => setPageEntries((p) => Math.max(1, p - 1))}
                  disabled={pageEntries === 1}
                >
                  Prev
                </button>
                <span className="pagination-text">
                  Page {pageEntries} of {totalEntryPages}
                </span>
                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    setPageEntries((p) => Math.min(totalEntryPages, p + 1))
                  }
                  disabled={pageEntries === totalEntryPages}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </>
      )}

      {/* -------------------------- */}
      {/* TAB 2 — MISSING CALENDAR   */}
      {/* -------------------------- */}
      {activeTab === "calendar" && (
        <div className="">
          <div className="card-header">
            <h1>Missing Entries Calendar</h1>
            <p className="text-muted">
              Select a month and year to see who missed filling daily sheets. Click a day to view employees.
            </p>
          </div>
          <div className="missing-cal-controls">
            <select
              className="filter-input"
              value={calMonth}
              onChange={(e) => setCalMonth(Number(e.target.value))}
            >
              {[
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ].map((m, idx) => (
                <option key={m} value={idx}>
                  {m}
                </option>
              ))}
            </select>
            <input
              type="number"
              className="filter-input"
              value={calYear}
              onChange={(e) => setCalYear(Number(e.target.value))}
              style={{ width: 110 }}
            />
            <div className="missing-cal-legend">
              <span className="legend-dot green" /> Filled
              <span className="legend-dot red" /> Missing
            </div>
          </div>

          <div className="missing-cal-grid">
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
              <div key={d} className="missing-cal-day header">
                {d}
              </div>
            ))}
            {Array.from({ length: startDay }).map((_, idx) => (
              <div key={`empty-${idx}`} className="missing-cal-day empty" />
            ))}
            {Array.from({ length: daysInMonth }).map((_, idx) => {
              const day = idx + 1;
              const dateStr = `${calYear}-${String(calMonth + 1).padStart(
                2,
                "0"
              )}-${String(day).padStart(2, "0")}`;
              const missing = missingMap.get(dateStr) ?? 0;
              const isFuture = dateStr > todayStr;
              const hasMissing = !isFuture && missing > 0;
              return (
                <div
                  key={dateStr}
                  className={`missing-cal-day ${
                    isFuture ? "future" : hasMissing ? "missing" : "filled"
                  }`}
                  onClick={() => !isFuture && handleCalDateClick(dateStr)}
                  style={{ cursor: isFuture ? "default" : "pointer" }}
                >
                  <span className="day-number">{day}</span>
                  <span className="missing-count">
                    {isFuture
                      ? "—"
                      : hasMissing
                      ? `${missing} missing`
                      : "All filled"}
                  </span>
                </div>
              );
            })}
          </div>

          {selectedCalDate && (
            <div style={{ marginTop: 16 }}>
              <h4>
                Missing on {selectedCalDate} ({missingList.length})
              </h4>
              {missingList.length === 0 ? (
                <p className="text-muted">All employees submitted entries.</p>
              ) : (
                <table className="table">
                  <thead>
                    <tr>
                      <th>Emp Code</th>
                      <th>Name</th>
                      <th>Department</th>
                    </tr>
                  </thead>
                  <tbody>
                    {missingList.map((emp) => (
                      <tr key={emp.id}>
                        <td>{emp.emp_code}</td>
                        <td>
                          {emp.first_name} {emp.last_name}
                        </td>
                        <td>{emp.department}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>
      )}

      {/* -------------------------- */}
      {/* TAB 3 — UPCOMING LEAVES   */}
      {/* -------------------------- */}
      {activeTab === "leaves" && canSeeUpcoming && (
        <div className="">
          <div className="card-header">
            <h1>Upcoming Leaves (Next 30 Days)</h1>
            <p className="text-muted">List of planned leaves</p>
          </div>

          {upcomingLeaves.length === 0 ? (
            <p className="text-muted" style={{ marginTop: 10 }}>
              No upcoming leaves found.
            </p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Emp Code</th>
                    <th>Name</th>
                    <th>Comment</th>
                    <th>Manager Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedLeaves.map((e, index) => (
                    <tr key={index}>
                      <td>{formatDate(e.entry_date)}</td>
                      <td>{e.emp_code}</td>
                      <td>
                        {e.first_name} {e.last_name}
                      </td>
                      <td style={{ whiteSpace: "pre-wrap" }}>{e.comment}</td>
                      <td>
                        <span className={statusBadgeClass(e.manager_status)}>
                          {e.manager_status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pagination-row">
                <button
                  className="btn btn-secondary"
                  onClick={() => setPageLeaves((p) => Math.max(1, p - 1))}
                  disabled={pageLeaves === 1}
                >
                  Prev
                </button>
                <span className="pagination-text">
                  Page {pageLeaves} of {totalLeavePages}
                </span>
                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    setPageLeaves((p) => Math.min(totalLeavePages, p + 1))
                  }
                  disabled={pageLeaves === totalLeavePages}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      )}

    </div>
    </div>
  );
};

export default AdminDailySheet;
